export default __webpack_public_path__ + "static/media/mapping-image.9687a311.svg";